import { isString } from "lodash-es";
import { coerce, date, define, type Infer, string } from "superstruct";

export const isoDate = define<string>(
    "isoDate",
    (v) => isString(v) && !Number.isNaN(new Date(v).valueOf()),
);
export type IsoDate = Infer<typeof isoDate>;
export const isoDateCoercer = coerce(date(), string(), (value) => new Date(value));

export function serializeIsoDate(date: Date): IsoDate;
export function serializeIsoDate(date: Date | null): IsoDate | null;
export function serializeIsoDate(date: Date | null): IsoDate | null {
    return date ? date.toISOString() : null;
}

export function deserializeIsoDate(date: IsoDate): Date;
export function deserializeIsoDate(date: IsoDate | null): Date | null;
export function deserializeIsoDate(date: IsoDate | null): Date | null {
    return date ? new Date(date) : null;
}
